import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import LightboxModal from '../components/LightboxModal';
import { SERVICES_GRID } from '../data/scrapeData';

export default function ServicesPage() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Ydelser – Vognmand & Entreprenør DBM aps"
        description="Vores ydelser: Vognmandskørsel, Kranarbejde, Grapning af slam og flydelag, Containerudlejning/service, Kornkørsel, Entreprenør- / nedbrydningsopgaver, Modtagelse af byggeaffald, Grus udlægnings kørsel, Halm kørsel, Stammetræs kørsel, Jernplade leje, Sorterings anlæg, Gylletrailer 39 m³, Buffer kasse 100 m³."
      />

      {/* Header Banner */}
      <section
        className="relative bg-cover bg-center bg-no-repeat text-white py-20 sm:py-32 px-4 sm:px-8 border-b-4 border-neutral-800 text-center flex items-center justify-center min-h-[350px] sm:min-h-[440px] mb-12"
        style={{
          backgroundImage:
            'url("https://assets.auxodev.dk/cdn-cgi/image/width=1920,quality=80,format=auto/assets/97798019-8392-40d4-89ba-059b36d499c2/2026-04-24-11-34-48.jpg")',
        }}
      >
        <div className="relative z-10 max-w-4xl mx-auto drop-shadow-lg [text-shadow:_0_2px_10px_rgba(0,0,0,0.8)]">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black tracking-tight text-white">
            Vores ydelser
          </h1>
          <p className="text-gray-200 text-base sm:text-xl mt-3 font-medium">
            Din lokale Vognmand & Entreprenør
          </p>
          <div className="mt-6">
            <Link
              to="/kontakt/"
              className="inline-block bg-black hover:bg-neutral-800 text-white font-bold px-8 py-3.5 rounded text-sm uppercase tracking-wider border border-white/30 transition-colors shadow-lg"
            >
              Kontakt os her
            </Link>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-8 pb-12">

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-6 gap-6 sm:gap-8">
          {SERVICES_GRID.map((item, index) => {
            const total = SERVICES_GRID.length;
            const rem3 = total % 3;
            const rem2 = total % 2;

            let lgSpan = "lg:col-span-2";
            if (rem3 === 1 && index === total - 1) {
              lgSpan = "lg:col-span-6";
            } else if (rem3 === 2 && index >= total - 2) {
              lgSpan = "lg:col-span-3";
            }

            let mdSpan = "md:col-span-1";
            if (rem2 === 1 && index === total - 1) {
              mdSpan = "md:col-span-2";
            }

            let smSpan = "sm:col-span-1";
            if (rem2 === 1 && index === total - 1) {
              smSpan = "sm:col-span-2";
            }

            const cardInner = (
              <div className="bg-white rounded shadow-md overflow-hidden border border-gray-200 hover:shadow-xl transition-shadow flex flex-col group h-full">
                <div className="relative h-56 sm:h-60 md:h-64 overflow-hidden bg-gray-100">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>

                <div className="p-5 flex-1 flex flex-col justify-center bg-white text-center">
                  <h2 className="text-lg font-bold text-gray-900 group-hover:text-black transition-colors">
                    {item.title}
                  </h2>
                </div>
              </div>
            );

            return item.href && item.href !== '#' ? (
              <Link key={index} to={item.href} className={`block h-full ${smSpan} ${mdSpan} ${lgSpan}`}>
                {cardInner}
              </Link>
            ) : (
              <div key={index} className={`block h-full ${smSpan} ${mdSpan} ${lgSpan}`}>
                {cardInner}
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/kontakt/"
            className="inline-block bg-gray-900 hover:bg-black text-white font-bold px-10 py-4 rounded uppercase tracking-wider text-sm transition-colors shadow-lg"
          >
            Kontakt os i dag
          </Link>
        </div>
      </div>

      <LightboxModal
        images={SERVICES_GRID.map(s => ({ src: s.image, title: s.title }))}
        currentIndex={lightboxIndex}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        onPrev={() => setLightboxIndex((prev) => (prev > 0 ? prev - 1 : SERVICES_GRID.length - 1))}
        onNext={() => setLightboxIndex((prev) => (prev < SERVICES_GRID.length - 1 ? prev + 1 : 0))}
      />
    </div>
  );
}
